var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"reports-empty-data"},[_vm._v(" Brak danych do wyświetlenia ")])}
var staticRenderFns = []

export { render, staticRenderFns }